export { default as MemorandumsTemplate } from "./MemorandumsTemplate";
export { default as MemorandumTemplate } from "./MemorandumTemplate";
